import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './VerifyEmail.less';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import { useAuth0 } from '@auth0/auth0-react';
import { TokenService } from '../../services/secureTokenService';
import { CirraServiceType } from '../../enums/auth';
import { getServiceHomeUrl } from '../../constants/route';
import { trackGTMPageView } from '../../utils/gtm';

const VerifyEmail = () => {
  const { logout } = useAuth0();
  const location = useLocation();
  // Prioritize email from location.state (passed by AuthErrorBoundary)
  // Then check localStorage (stored during signup form submission)
  // Do NOT fall back to user?.email — Auth0 caches user data in localStorage
  // (cacheLocation="localstorage"), so it may contain a stale email from a
  // previous session or a completely different user.
  const email = location.state?.email || localStorage.getItem('signup_email');
  const service = location.state?.service || CirraServiceType.MCP;

  // Track GTM page view
  useEffect(() => {
    trackGTMPageView('/verify-email', 'Verify Email');
  }, []);

  // Enable scrolling for this page (override global overflow: hidden)
  useEffect(() => {
    // Store original body overflow
    const originalOverflow = document.body.style.overflow;

    // Enable scrolling
    document.body.style.overflow = 'auto';

    return () => {
      // Restore original overflow when component unmounts
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  const handleBackToLogin = () => {
    TokenService.clearTokens();
    // Clear stale signup data so the next login attempt doesn't show the wrong email
    localStorage.removeItem('signup_email');
    localStorage.removeItem('signup_session_id');
    localStorage.removeItem('signup_correlation_id');
    logout({
      logoutParams: {
        returnTo: getServiceHomeUrl(service),
      },
    });
  };

  return (
    <div id="verify-email-container">
      <div className="verify-email-icon">
        <Logo />
      </div>
      <h1>Verify your email address</h1>
      <p>
        We have sent you a verification email. Please click the link provided in
        the email to complete your account registration.
      </p>
      <p>
        You will be able to login to your account once you have verified your
        email address.
      </p>
      <p className="support-msg">
        If you cannot locate the email, please check your{' '}
        <strong>spam folder</strong>, or contact us at{' '}
        <Link to="mailto:support@cirra.ai">support@cirra.ai</Link>
      </p>
      {email ? (
        <p className="connected-email">
          You are connected as {email}.{' '}
          <button onClick={handleBackToLogin} className="not-you-link">
            Not you?
          </button>
        </p>
      ) : (
        <p className="connected-email">
          <button onClick={handleBackToLogin} className="not-you-link">
            Back to login page
          </button>
        </p>
      )}
    </div>
  );
};

export default VerifyEmail;
